export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "total_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total de paquetes"])},
          "quantity_available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad disponible"])},
          "quantity_assigned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad asignada"])}
        }
      }
    }
  })
}